<template>
    <v-card flat class="mt-2 mr-2">
        <v-snackbar v-model="snackbar.active" :color="snackbar.color" :timeout="4000" top >    
            <span> {{snackbar.message}} </span>
            <v-btn text @click="snackbar.active = false">Close</v-btn>
        </v-snackbar>  
        <v-row dense align-content="center" justify="center">
            <v-col cols="8">
                <v-form ref="form">
                    <v-row dense>                
                        <v-col cols="6">
                            <v-spacer></v-spacer>
                            <v-text-field v-model="nome" :rules="[rules.required]" label="Inclua o Nome do Layout * " required></v-text-field>
                            <!-- <v-select v-model="position" :items="positions" label="Selecione a Posição das Imagens"></v-select>                     -->
                        </v-col>                 
                        <v-col cols="6">
                            <v-file-input  
                                :rules="rules"
                                v-model="imgStore"
                                accept="image/*"
                                label="Clique para Carregar uma Imagem para o Banner"
                                prepend-icon="mdi-camera"
                                @change="onFileChange">
                            </v-file-input>                
                        </v-col>                 
                        <v-col cols="6">
                            <colorPicker v-model="primaryColor" :title="'Selecione a Cor Primária'" :mainColor="'#296B74'" @colorSelect='primaryColor = $event'/>
                        </v-col> 
                        <v-col cols="6">
                            <colorPicker v-model="secondaryColor" :title="'Selecione a Cor Secundária'" :mainColor="'#296B74'" @colorSelect='secondaryColor = $event'/>
                        </v-col> 
                        <v-col cols="6">
                            <v-textarea v-model="mensagemInicio" label="Digite uma Mensagem de Boas Vindas" ></v-textarea>                    
                        </v-col> 
                        <v-col cols="6">
                            <v-textarea v-model="mensagemAgradecimento" label="Digite uma Mensagem de Agradecimento"></v-textarea>                    
                        </v-col>    
                        <v-col cols="12">
                            <v-divider/>
                        </v-col>        
                        <v-col cols="12" class="text-right">
                            <v-btn outlined class="ma-2 white--text" color="primary" @click="saveInfo">
                                <v-icon left dark>mdi-plus</v-icon>
                                Salvar Informações
                            </v-btn>                      
                        </v-col>                                                                                      
                    </v-row>     
                </v-form>              
                <v-row>
                    <v-spacer></v-spacer>                
                </v-row>
            </v-col>
            <v-col cols="1">
                <v-spacer></v-spacer>
            </v-col>
            <v-col cols="3">
                <device :scale="10">
                    <v-card :color="secondaryColor">
                        <v-row dense align="center" align-content="center" justify="center">
                            <v-col cols="12" class="text-center pt-0 pb-0">
                                <v-card tile height="50px" :color="primaryColor">
                                    <v-img max-height="50px" :src="this.logoFile"/>
                                </v-card>
                            </v-col>
                        </v-row>
                        <v-row dense no-gutters width="100%" align="center" align-content="center" justify="center">
                            <v-col cols="8">
                                <v-flex text-xs-center fill-height>
                                    <v-card tile class="pa-2" height="200px" outlined :color="primaryColor">

                                    </v-card>                        
                                </v-flex>
                            </v-col>                                      
                        </v-row>
                        <v-row dense align="center" align-content="center" justify="center">
                            <v-col cols="12" class="text-center pt-0 pb-0">
                                <v-card tile height="32px" :color="primaryColor">
                                </v-card>
                            </v-col>
                        </v-row>                    
                    </v-card>
                </device>
            </v-col>         
        </v-row>
    </v-card>
</template>
<script>
import device from 'vue-and-devices-mocks'
import colorPicker from '@/components/general/colorpicker'
import {db, files} from '@/main'

    export default {
        components: {device,colorPicker},
        data() {
            return {
                snackbar: {
                    'active':false,
                    'color':'success',
                    'message':'Deu Certo'
                },                  
                menu: false,
                color: '#1CA085',
                primaryColor: '#296B74',
                secondaryColor: '#1C4C5A',
                positions: ['Esquerdo','Centralizado','Direito'],
                position: 'center',
                mensagemInicio: '',
                mensagemAgradecimento: '',
                rules: {
                    required: value => !!value || 'Campo Obrigatório.',                
                },
                props: {
                    type: 'ipad',
                    scale: 10,
                    width: null,
                    height: null,
                },
                imgStore: 'https://lh3.googleusercontent.com/proxy/fiGHDfrk5pudjLBwRySutT17pJNIxYgKLkpabWxmjgyv-SpJk3Kk4NexK49TLV69D3Kzbdnp4a6xv1KqKWEakd5PUSe1ZyHHFQ',
                logoFile: ''
            }
        },
        async created(){
            let ref = files.ref();

            this.nome = this.$store.getters.company.data.design.nome
            this.primaryColor = this.$store.getters.company.data.design.corPrimaria
            this.secondaryColor = this.$store.getters.company.data.design.corSecundaria
            this.mensagemInicio = this.$store.getters.company.data.design.mensagemInicio
            this.mensagemAgradecimento = this.$store.getters.company.data.design.mensagemAgradecimento
            let logo
            await ref.child(this.$store.getters.company.data.design.logo).getDownloadURL().then(function(url){
                logo = url
            })  
            this.logoFile = logo.toString()     
        },
        methods:{
            async saveInfo(){
                if (this.$refs.form.validate()) {
                    let companyDesign = {
                        'design':{ 
                            nome: this.nome,
                            corPrimaria: this.primaryColor,
                            corSecundaria: this.secondaryColor,
                            mensagemInicio: this.mensagemInicio,
                            mensagemAgradecimento: this.mensagemAgradecimento
                        }
                    }
                
                   let ref = files.ref();

                    if (typeof this.imgStore.name != 'undefined'){ 
                        let imgName = 'logoPortal' + this.imgStore.name.substring(this.imgStore.name.lastIndexOf("."), this.imgStore.name.length)
                        let mountainImagesRef = await ref.child(this.$store.getters.company.data.id+'/images/'+imgName);
                        imgName = this.$store.getters.company.data.id+'/images/'+imgName
                        await mountainImagesRef.put(this.imgStore).then(function() {
                            console.log('Uploaded a blob or file!');
                            companyDesign['design'].logo = imgName
                        });                                
                    }
                    console.log(companyDesign)
                    db.collection('empresas').doc(this.$store.getters.company.data.id).update(companyDesign).then(async() => {
                        this.loading = false
                        this.snackbar = {
                            'active':true,
                            'color':'success',
                            'message':'Informações Salvas com Sucesso'
                        }                
                        // await this.reloadData(this.$store.getters.company.data.id)
                    }).catch(function (error) {
                        this.snackbar = {
                            'active':true,
                            'color':'error',
                            'message': error
                        }          
                        console.error('Error to Save Information - storePage : ' + error)
                    }) 
                } 
            },
            onFileChange() {
                console.log(this.imgStore)
            
                let name = 'logo' + this.imgStore.name.substring(this.imgStore.name.lastIndexOf("."), this.imgStore.name.length)
                console.log(name)

                const file = this.imgStore;
                this.logoFile = URL.createObjectURL(file);
            },             
        }
    }
</script>